// src/api/services/shopService.js
import api from '../interceptors/axiosInterceptor';
import API_CONFIG from '@/api/config';
import axios from 'axios';
const SHOP_ENDPOINTS = {
  GET_CONTACT_US: '/store/public-store-contact-us/',
  DETAILS: '/store/details/',
  BANER: '/store/public-store-banner/',
  GET_CAMPAIN: '/store/public-store-campaign/',
  CATEGORIES: '/store/public-store-category/',
  GET_SHOP: '/store/public-get/',
  STORE_SETTINGS: '/store/public-store-settings/',
  GET_SHOP_PRODUCT_SORT_BY_CATEGORY: '/shop/products-sort-by-category/',
  GET_SHOP_PRODUCTS: '/shop/products-all/',
  GET_SHOP_NEW_PRODUCTS: '/shop/products-new/',
  GET_SHOP_PRODUCT_DETAILS: '/shop/product/get/',
  PRODUCTS_BY_CATEGORY: '/shop/products-one-category/',
  BY_CATEGORY: '/shop/category',
  STATS: '/shop/stats',
  CARD: '/shop/stats',
  TOP_SALES: '/shop/products-top-sales/',
  VERIFY: '/shops/verify',
  SHIPPING_METHODS: '/shop/shipping-methods/',
  APPLY_DISCOUNT: '/shop/cart/',
  PAY: '/shop/orders/',
  ORDERS_LIST: '/shop/orders/',
  CART_ITEMS: '/shop/cart/items/',
  LEADS: '/shop/leads/'
};

const storeSlug = window.__STORE_INFO__?.slug || "mmd1";
const slug = storeSlug;

const ShopService = {
  createTicket: async (data) => {
    try {
      const response = await axios.post(
        `${API_CONFIG.BASE_URL}/manager/guest/create-ticket/`,
        {
          store_id: data.store_id,
          guest_name: data.guest_name,
          guest_phone: data.guest_phone,
          subject: data.subject,
          message: data.message
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        }
      );
      return response.data;
    }
    catch (error) {
      throw error.response?.data || { message: 'خطای ناشناخته' };
    }
  },
  async getStoreBanners() {
    const storeSlug = window.__STORE_INFO__?.slug;

    try {

      const response = await api.get(
        `${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.BANER}${storeSlug}/`

      );
      return {
        success: true,
        data: response.data,
        message: "بنرها با موفقیت دریافت شدند",
      };
    } catch (error) {
    }
  },
  async getShopCategory() {
    try {
      const url = `${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.CATEGORIES}${slug}/`;
      const response = await api.get(url);

      if (!response.data) return [];

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },
  async postShopLeads({ phone, productId }) {
    try {
      const storeSlug = window.__STORE_INFO__?.slug || slug;
      const url = `${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.LEADS}${storeSlug}/`;
      const response = await api.post(url, {
        phone,
        product: productId,
      });

      if (!response.data) return [];

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },
  async getFaqs() {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}/shop/faqs/${slug}/`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async createOrder(orderData) {
    try {
      const storeSlug = window.__STORE_INFO__?.slug || localStorage.getItem('shop_slug');
      const url = `${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.PAY}${storeSlug}/create/`;
      const response = await api.post(url, orderData);
      if (response && response.data) {
        return response.data.payment_url || response.data;
      }
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getOrders(params = {}) {
    try {
      const storeSlug = window.__STORE_INFO__?.slug || localStorage.getItem('shop_slug');
      const url = `${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.ORDERS_LIST}${storeSlug}/`;
      const response = await api.get(url, { params });
      let ordersData = [];
      if (response && Array.isArray(response)) {
        ordersData = response;
      } else if (response && response.results && Array.isArray(response.results)) {
        ordersData = response.results;
      } else if (response && response.data && Array.isArray(response.data)) {
        ordersData = response.data;
      } else if (response && response.items && Array.isArray(response.items)) {
        ordersData = response.items;
      } else {
        ordersData = [];
      }
      return ordersData;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getOrderDetail(orderId) {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.ORDERS_LIST}${slug}/${orderId}/`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getUserOrders(params = {}) {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.ORDERS_LIST}${slug}/`, {
        params: { ...params, user_orders: true }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getAllShops(params = {}) {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.GET_SHOP}`, { params });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getStoreSettings() {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.STORE_SETTINGS}${slug}/`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async loadSuggestedProducts() {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.GET_CONTACT_US}${slug}/`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getStoreContact() {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.GET_CONTACT_US}${slug}/`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  updateUserProfile(store_slug, data) {
    // فرض بر این است که axios در scope موجود است یا ایمپورت شده
    return axios.put(`/v1/api/user/profile/update/${store_slug}/`, data, {
      headers: {
        'Authorization': `Token ${localStorage.getItem('auth_token')}`
      }
    });
  },

  updateUserProfileAlternative(store_slug, userId, data) {
    return axios.put(`/v1/api/user/update/${store_slug}/${userId}/`, data, {
      headers: {
        'Authorization': `Token ${localStorage.getItem('auth_token')}`
      }
    });
  },

  async getShopById(shopId) {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.DETAILS}${shopId}/`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getShopCampain() {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.GET_CAMPAIN}${slug}/`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getShopNewProducts() {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.GET_SHOP_NEW_PRODUCTS}${slug}/`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getShopTopSales() {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.TOP_SALES}${slug}/`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getProductSortByCategory() {

    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.GET_SHOP_PRODUCT_SORT_BY_CATEGORY}${slug}/`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getShopProducs() {

    return this.getShopProducts(

    );
  },

  async getShopProducts() {

    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.GET_SHOP_PRODUCTS}${slug}/`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

/**
 * دریافت جزئیات محصول (اصلاح شده برای بازگرداندن کامل اطلاعات)
 */
async getShopProductDetail(productIdentifier) {
  try {
    const storeSlug = window.__STORE_INFO__?.slug || 'mmd1';
    let url = `${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.GET_SHOP_PRODUCT_DETAILS}${storeSlug}/${productIdentifier}/`;

    const response = await api.get(url);
    const data = response.data;
    
    return {
      // اطلاعات پایه
      id: data.id,
      name: data.name,
      slug: data.slug,
      
      // قیمت و تخفیف
      price: data.price,
      discount: data.discount,
      original_price: data.original_price || null,
      final_price: data.final_price || null,
      
      // وضعیت موجودی - این فیلدها مهم هستند
      is_available: data.is_available !== undefined ? data.is_available : true,
      total_stock: data.total_stock || data.stock || 0,
      stock: data.stock || data.total_stock || 0,
      status: data.status || (data.is_available ? 'available' : 'unavailable'),
      status_display: data.status_display || (data.is_available ? 'موجود' : 'ناموجود'),
      
      // تصاویر و رسانه
      image: data.image || null,
      images: data.images || [],
      
      // امتیازات
      average_rating: data.average_rating || 0,
      review_count: data.review_count || 0,
      
      // دسته‌بندی
      category: data.category || null,
      category_slug: data.category_slug || null,
      category_name: data.category_name || "بدون دسته بندی",
      
      // توضیحات
      short_description: data.short_description || '',
      description: data.description || '',
      
      // آپشن‌ها و واریانت‌ها
      options: data.options || [],
      variants: data.variants || [],
      
      // اطلاعات اضافی که ممکنه API برگردونه
      meta_title: data.meta_title || data.name || '',
      meta_description: data.meta_description || data.short_description || '',
      tags: data.tags || [],
      brand: data.brand || null,
      brand_name: data.brand_name || null,
      weight: data.weight || null,
      dimensions: data.dimensions || null,
      sku: data.sku || null,
      
      // فروشنده (اگر چند فروشنده‌ای هستید)
      vendor: data.vendor || null,
      vendor_name: data.vendor_name || null,
      
      // تاریخ‌ها
      created_at: data.created_at || null,
      updated_at: data.updated_at || null,
      
      // سایر فیلدهایی که ممکنه نیاز بشه
      min_order_quantity: data.min_order_quantity || 1,
      max_order_quantity: data.max_order_quantity || null,
      is_featured: data.is_featured || false,
      is_new: data.is_new || false,
      has_discount: data.has_discount || (data.discount > 0),
    };

  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null;
    }
    throw this.handleError(error);
  }
},

  async getActiveCampaigns() {
    try {
      const storeSlug = window.__STORE_INFO__?.slug || 'mmd1';
      const url = `${API_CONFIG.BASE_URL}/shop/campains/${storeSlug}/`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      return [];
    }
  },

  async getProductReviews(productId) {
    try {
      if (!productId || typeof productId !== 'number' && isNaN(Number(productId))) {
        return [];
      }
      const url = `${API_CONFIG.BASE_URL}/shop/products/${productId}/reviews/`;
      const response = await api.get(url);
      return response.data || [];
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return [];
      }
      return [];
    }
  },
  async getShopCategories() { // ⚠️ نام متفاوت: Categories (جمع)
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.CATEGORIES}${slug}/`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getMyShops() {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.MY_SHOPS}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async searchShops(query, filters = {}) {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.SEARCH}`, {
        params: { q: query, ...filters }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },


  async getShopsByCategory(categoryId, params = {}) {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.BY_CATEGORY}/${categoryId}`, { params });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getShopStats(shopId) {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.STATS}/${shopId}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async verifyShop(shopId, status) {
    try {
      const response = await api.patch(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.VERIFY}/${shopId}`, { status });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async trackOrder(trackingData) {
    try {
      const response = await api.post(`${API_CONFIG.BASE_URL}/shop/orders/${slug}/track/`, trackingData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getOrderByTracking(phone, orderId) {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}/shop/orders/${slug}/track/`, {
        params: { phone_number: phone, order_id: orderId }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getStore() {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.GET_SHOP}${slug}/`);
      if (response.data && typeof response.data.is_lead_store !== 'undefined') {
        localStorage.setItem('is_lead_store', response.data.is_lead_store ? '1' : '0');
      }
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  isLeadStore() {
    return localStorage.getItem('is_lead_store') === '1';
  },

  async submitLeadOrderRequest({ phone, productName, productId, productPrice }) {
    const storeId = window.__STORE_INFO__?.id || window.__STORE_INFO__?.slug || slug;
    return await this.createTicket({
      store_id: storeId,
      guest_name: 'مشتری - درخواست سفارش',
      guest_phone: phone,
      subject: 'order',
      message: `درخواست سفارش محصول: ${productName} (شناسه: ${productId})${productPrice ? ` - قیمت: ${productPrice}` : ''}`
    });
  },

  async addToCart(productId, variantId = null, quantity = 1) {
    if (this.loading) return Promise.resolve({ success: false, error: 'در حال پردازش...' });
    this.loading = true;

    const payload = {
      product_id: productId,
      quantity: Number(quantity)
    };

    if (variantId !== null && variantId !== undefined) {
      payload.variant_id = variantId;
    }

    try {
      const storeSlug = window.__STORE_INFO__?.slug;
      const response = await api.post(
        `${API_CONFIG.BASE_URL}/shop/cart/${storeSlug}/items/`,
        payload,
        {
          withCredentials: true,
          timeout: 10000,
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        }
      );
      window.dispatchEvent(
        new CustomEvent("cart-updated", {
          detail: {
            item: response.data
          }
        })
      );

      return {
        success: true,
        data: response.data,
        message: 'محصول با موفقیت به سبد خرید اضافه شد'
      };

    } catch (error) {
      if (error.response) {
        const errorData = error.response.data;
        let errorMessage = 'خطا در افزودن به سبد خرید';

        if (errorData.error) errorMessage = errorData.error;
        else if (errorData.detail) errorMessage = errorData.detail;
        else if (typeof errorData === 'string') errorMessage = errorData;
        else if (errorData.non_field_errors) errorMessage = errorData.non_field_errors[0];

        return {
          success: false,
          status: error.response.status,
          error: errorMessage,
          data: errorData
        };
      }

      if (error.code === 'ECONNABORTED') {
        return { success: false, error: 'اتصال به سرور زمان‌بر شد.' };
      }

      return { success: false, error: 'خطای شبکه. لطفاً اینترنت خود را بررسی کنید' };

    } finally {
      this.loading = false;
    }
  },

  async getCart() {
    try {
      const storeSlug = window.__STORE_INFO__?.slug;
      const url = `${API_CONFIG.BASE_URL}/shop/cart/${storeSlug}/`;
      const response = await api.get(url, { withCredentials: true });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async updateCartItem(storeSlug, itemId, quantity) {
    try {
      const url = `${API_CONFIG.BASE_URL}/shop/cart/${storeSlug}/items/${itemId}/`;
      const response = await api.put(url, { quantity: quantity });
      window.dispatchEvent(
        new CustomEvent("cart-updated", {
          detail: {
            item: response.data
          }
        })
      );


      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async removeCartItem(storeSlug, itemId) {
    try {
      const url = `${API_CONFIG.BASE_URL}/shop/cart/${storeSlug}/items/${itemId}/`;
      const response = await api.delete(url);
      window.dispatchEvent(
        new CustomEvent("cart-updated", {
          detail: {
            item: response.data
          }
        })
      );


      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async getShippingMethods() {
    try {
      const response = await api.get(`${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.SHIPPING_METHODS}${slug}/`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async applyDiscount(code) {
    try {
      const storeSlug = window.__STORE_INFO__?.slug || 'mmd1';
      const url = `${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.APPLY_DISCOUNT}${storeSlug}/apply-discount/`;
      const response = await api.post(url, code);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async checkout(data) {
    try {
      const storeSlug = window.__STORE_INFO__?.slug || 'mmd1';
      const url = `${API_CONFIG.BASE_URL}${SHOP_ENDPOINTS.PAY}${storeSlug}/create/`;
      const response = await api.post(url, data);
      if (response.data) {
        return response.data.payment_url;
      }
    } catch (error) {
      throw this.handleError(error);
    }
  },

  handleError(error) {
    const errorInfo = {
      message: 'یک خطا رخ داده است',
      status: -1
    };

    if (error?.response) {
      errorInfo.message = error.response.data?.message || 'خطای سرور رخ داده است';
      errorInfo.status = error.response.status;
      errorInfo.data = error.response.data;
    } else if (error?.request) {
      errorInfo.message = 'اتصال به سرور برقرار نشد';
      errorInfo.status = 0;
    } else if (error?.message) {
      errorInfo.message = error.message;
    }

    return errorInfo;
  }
};

export default ShopService;